import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import SubidsGrid from '../components/Grid';
import { SubidProvider } from '../store';

import SubidFormLayout from './Form';

export default function SubidsGridLayout() {
  return <SubidProvider>
    <SubidsGrid />
    <Router>
      <PrivateRoute exact path={"/offer/allocations/:allocationID/subids/add"} component={SubidFormLayout} />
      <PrivateRoute path={"/offer/allocations/:allocationID/subids/:id"} component={SubidFormLayout} />
    </Router>
  </SubidProvider>;
}
